import { render, staticRenderFns } from "./toGroup.vue?vue&type=template&id=5641d346&"
import script from "./toGroup.vue?vue&type=script&lang=js&"
export * from "./toGroup.vue?vue&type=script&lang=js&"
import style0 from "./toGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports